<tt-page>
    <tt-page-heading>{{ heading }}</tt-page-heading>
    <tt-material-grade [params]="params" (getLoaded)="heading = $event.webpage_heading" (submit)="onSubmit()"></tt-material-grade>
</tt-page>
